/**
 * Accessibility (a11y) & Keyboard Navigation Shortcut Manager
 * Enables WCAG 2.1 AA keyboard shortcuts and high contrast accessibility mode.
 */

export const initA11yKeyboardShortcuts = () => {
  if (typeof window === 'undefined') return;

  const handleKeyDown = (e) => {
    // Alt + B: Quick focus Consultation booking
    if (e.altKey && (e.key === 'b' || e.key === 'B')) {
      e.preventDefault();
      const bookingBtn = document.querySelector('button[onClick*="openCalendlyModal"]');
      if (bookingBtn) {
        bookingBtn.focus();
        bookingBtn.click();
      }
    }

    // Alt + N: Quick focus Newsletter subscription email input
    if (e.altKey && (e.key === 'n' || e.key === 'N')) {
      e.preventDefault();
      const newsletterInput = document.querySelector('input[aria-label="Имейл адрес за бюлетин"]');
      if (newsletterInput) {
        newsletterInput.focus();
      }
    }

    // Alt + A: Toggle High-Contrast Accessibility Focus Ring Mode
    if (e.altKey && (e.key === 'a' || e.key === 'A')) {
      e.preventDefault();
      document.body.classList.toggle('a11y-high-contrast');
      const isHighContrast = document.body.classList.contains('a11y-high-contrast');
      announceScreenReader(`Висок контраст ${isHighContrast ? 'активиран' : 'деактивиран'}`);
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
};

export const announceScreenReader = (message) => {
  if (typeof document === 'undefined') return;
  let srRegion = document.getElementById('a11y-status-announcer');
  if (!srRegion) {
    srRegion = document.createElement('div');
    srRegion.id = 'a11y-status-announcer';
    srRegion.setAttribute('role', 'status');
    srRegion.setAttribute('aria-live', 'assertive');
    srRegion.className = 'sr-only border-0 clip-rect-0 h-1px w-1px overflow-hidden absolute';
    document.body.appendChild(srRegion);
  }
  srRegion.textContent = message;
};
